import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { type ChainData } from '@/shared/assets/chains';
import { integrationManager } from '@/shared/integrations';
import { deduplicater } from '@/shared/utils/arrays';

interface ChainsData {
  chains: ChainData[];
  isLoading: boolean;
  error: boolean;
}

const deduplicateChains = deduplicater<ChainData>((c) => c.id);

const useChains = (sourceChain?: ChainData): ChainsData => {
  const {
    data: chainflipChains,
    error: chainflipError,
    isLoading: chainflipLoading,
  } = useQuery({
    queryKey: ['CHAINFLIP_CHAINS', sourceChain?.id],
    queryFn: async () => {
      const cf = integrationManager.getIntegration('chainflip');

      if (sourceChain) {
        return cf.getDestinationChains(sourceChain.id);
      }

      return cf.getChains();
    },
  });

  const chains = useMemo(() => deduplicateChains([...(chainflipChains ?? [])]), [chainflipChains]);

  return {
    chains,
    isLoading: chainflipLoading,
    error: Boolean(chainflipError), // TODO: handle error view
  };
};

export default useChains;
